document.addEventListener("DOMContentLoaded", function () {
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function slideDown(el, duration) {
    el.style.transition = "";
    el.style.height = "";
    el.style.overflow = "";
    el.style.display = "block";

    let targetHeight = el.scrollHeight;
    el.style.overflow = "hidden";
    el.style.height = "0";

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.transition = "height " + duration + "ms ease";
        el.style.height = targetHeight + "px";
      });
    });

    el.addEventListener(
      "transitionend",
      function handler() {
        el.style.height = "";
        el.style.overflow = "";
        el.style.transition = "";
        el.removeEventListener("transitionend", handler);
      },
      {once: true},
    );
  }

  function slideUp(el, duration) {
    let currentHeight = el.offsetHeight;
    if (currentHeight === 0) {
      el.style.display = "none";
      el.style.height = "";
      el.style.overflow = "";
      el.style.transition = "";
      return;
    }

    el.style.transition = "";
    el.style.overflow = "hidden";
    el.style.height = currentHeight + "px";

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.transition = "height " + duration + "ms ease";
        el.style.height = "0";
      });
    });

    el.addEventListener(
      "transitionend",
      function handler() {
        el.style.display = "none";
        el.style.height = "";
        el.style.overflow = "";
        el.style.transition = "";
        el.removeEventListener("transitionend", handler);
      },
      {once: true},
    );
  }

  function isOpen(el) {
    return el && el.offsetHeight > 0;
  }

  document.addEventListener("click", function (e) {
    let header = e.target.closest(".faq-directory__category-header");
    if (!header || !isMobile()) return;

    e.preventDefault();
    let item = header.closest(".faq-directory__category");
    let accordion = item.closest(".faq-directory__accordion");
    let content = item.querySelector(".faq-directory__category-content");
    let isActive = item.classList.contains("active");

    accordion
      .querySelectorAll(".faq-directory__category")
      .forEach(function (cat) {
        if (cat === item) return;
        cat.classList.remove("active");
        let c = cat.querySelector(".faq-directory__category-content");
        if (isOpen(c)) slideUp(c, 300);
      });

    if (!isActive) {
      item.classList.add("active");
      slideDown(content, 300);
    } else {
      item.classList.remove("active");
      slideUp(content, 300);
    }
  });

  document.addEventListener("click", function (e) {
    let link = e.target.closest(".faq-nav-link");
    if (!link || isMobile()) return;

    e.preventDefault();
    let target = document.querySelector(link.getAttribute("href"));
    if (target) {
      target.scrollIntoView({behavior: "smooth", block: "start"});
      document.querySelectorAll(".faq-nav-link").forEach(function (l) {
        l.classList.remove("active");
      });
      link.classList.add("active");
    }
  });

  document.addEventListener("click", function (e) {
    let header = e.target.closest(".faq-directory__subsection-header");
    if (!header) return;

    e.preventDefault();
    let item = header.closest(".faq-directory__subsection");
    let accordion = item.closest(".faq-directory__subsections");
    let content = item.querySelector(".faq-directory__subsection-content");
    let isActive = item.classList.contains("active");

    accordion
      .querySelectorAll(".faq-directory__subsection")
      .forEach(function (sub) {
        if (sub === item) return;
        sub.classList.remove("active");
        let c = sub.querySelector(".faq-directory__subsection-content");
        if (isOpen(c)) slideUp(c, 300);
      });

    if (!isActive) {
      item.classList.add("active");
      slideDown(content, 300);
    } else {
      item.classList.remove("active");
      slideUp(content, 300);
    }
  });

  document.addEventListener("click", function (e) {
    let header = e.target.closest(".faq-directory__item-header");
    if (!header) return;

    e.preventDefault();
    let item = header.closest(".faq-directory__item");
    let accordion = item.closest(".faq-directory__items");
    let content = item.querySelector(".faq-directory__item-content");
    let isActive = item.classList.contains("active");

    accordion.querySelectorAll(".faq-directory__item").forEach(function (fi) {
      if (fi === item) return;
      fi.classList.remove("active");
      let c = fi.querySelector(".faq-directory__item-content");
      if (isOpen(c)) slideUp(c, 300);
    });

    if (!isActive) {
      item.classList.add("active");
      slideDown(content, 300);
    } else {
      item.classList.remove("active");
      slideUp(content, 300);
    }
  });

  let observer;

  function initializeObserver() {
    if (isMobile() || observer) return;

    let navLinks = document.querySelectorAll(".faq-nav-link");
    let categories = document.querySelectorAll(".faq-directory__category");

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let id = entry.target.getAttribute("id");
            navLinks.forEach(function (link) {
              link.classList.toggle(
                "active",
                link.getAttribute("href") === "#" + id,
              );
            });
          }
        });
      },
      {root: null, rootMargin: "-20% 0px -70% 0px", threshold: 0.1},
    );

    categories.forEach(function (cat) {
      observer.observe(cat);
    });
  }

  function destroyObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function handleAnchorLinks() {
    let hash = window.location.hash;
    if (!hash) return;

    let target = document.querySelector(hash);
    if (!target) return;

    if (target.classList.contains("faq-directory__category")) {
      target.scrollIntoView({behavior: "smooth", block: "start"});
      if (!isMobile()) {
        document.querySelectorAll(".faq-nav-link").forEach(function (link) {
          link.classList.toggle("active", link.getAttribute("href") === hash);
        });
      }
    } else if (target.classList.contains("faq-directory__item")) {
      let subsection = target.closest(".faq-directory__subsection");
      if (subsection) {
        subsection.classList.add("active");
        let sc = subsection.querySelector(".faq-directory__subsection-content");
        if (sc) sc.style.display = "block";
      }
      target.classList.add("active");
      let ic = target.querySelector(".faq-directory__item-content");
      if (ic) ic.style.display = "block";
      setTimeout(function () {
        target.scrollIntoView({behavior: "smooth", block: "start"});
      }, 100);
    }
  }

  window.addEventListener("resize", function () {
    document
      .querySelectorAll(".faq-directory__category")
      .forEach(function (cat) {
        cat.classList.remove("active");
      });
    document.querySelectorAll(".faq-nav-link").forEach(function (l) {
      l.classList.remove("active");
    });

    if (!isMobile()) {
      document
        .querySelectorAll(".faq-directory__category-content")
        .forEach(function (el) {
          el.style.display = "block";
        });
      destroyObserver();
      initializeObserver();
    } else {
      document
        .querySelectorAll(".faq-directory__category-content")
        .forEach(function (el) {
          el.style.display = "none";
        });
      destroyObserver();
    }
  });

  if (!isMobile()) {
    document
      .querySelectorAll(".faq-directory__category-content")
      .forEach(function (el) {
        el.style.display = "block";
      });
  }
  handleAnchorLinks();
  initializeObserver();

  window.addEventListener("hashchange", handleAnchorLinks);
});
